import React from 'react';
import styled from '../../styled';
import * as Loading from '.';
const FlexWrapper = styled.div `
  display: flex;
  align-items: center;
`;
const ElementWrapper = styled.div `
  padding: 0.5rem;
  width: ${props => (props.width ? `${props.width}px` : '100%')};
`;
export const AvatarWithInfo = ({ avatarWidth = 40, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(FlexWrapper, null,
            React.createElement(ElementWrapper, { width: avatarWidth },
                React.createElement(Loading.AvatarRect, { width: avatarWidth })),
            React.createElement(ElementWrapper, null,
                React.createElement(Loading.BodyText, null)))));
};
//# sourceMappingURL=AvatarWithInfo.js.map